import { render, staticRenderFns } from "./BlipDeskProductivityTable.vue?vue&type=template&id=97beaf56&scoped=true&"
import script from "./BlipDeskProductivityTable.vue?vue&type=script&lang=js&"
export * from "./BlipDeskProductivityTable.vue?vue&type=script&lang=js&"
import style0 from "./BlipDeskProductivityTable.vue?vue&type=style&index=0&id=97beaf56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97beaf56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VDataTable,VRow})
